<template>
    <div></div>
</template>

<script>

export default {
    name: 'FuturesBalanceDeltaActionGraphWidgetParams',
    emits: ['update-params'],
    props: {
        demo: {
            type: Boolean,
            default: false
        },
        params: {
            required: true
        },
        errors: {
            required: true
        }
    },
    setup () {

    }
}
</script>
